import { User } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { isTenantManager, isSuperAdmin } from 'utils/auth';
import OrganizationTable from './OrganizationTable';
import { useUserStateStore } from 'zstore/userStateStore';
import styles from './index.module.css';

const TenantManagementBody = () => {
  const { user } = useUserStateStore();

  // Redirect if user is not a tenantmanager or superadmin
  if (!(isTenantManager(user as User) || isSuperAdmin(user as User))) {
    return <Navigate to="/" />;
  }

  return (
    <div className={styles.root}>
      <OrganizationTable />
    </div>
  );
};

export default TenantManagementBody;
